class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
//     this.header = document.querySelector('.header-wrapper');
//     this.mainDetailsToggle.addEventListener('mouseenter', this.onOpen.bind(this));
//     this.mainDetailsToggle.addEventListener('mouseleave', this.onClose.bind(this));
//     this.mainDetailsToggle.addEventListener('click', function(e){e.preventDefault()});
//   }

//   onOpen() {
//     if (!this.header) return;
//     this.mainDetailsToggle.open = true;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }

//   onClose() {
//     if (!this.header) return;
//     this.mainDetailsToggle.open = false;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }

//   onToggle() {
//     return;
//     // if (!this.header) return;
//     // this.header.preventHide = this.mainDetailsToggle.open;

//     // if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     // document.documentElement.style.setProperty(
//     //   '--header-bottom-position-desktop',
//     //   `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     // );
//   }
// }

// customElements.define('header-menu', HeaderMenu);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.header = document.querySelector('.header-wrapper');

    // Prevent native click toggle
    this.summary.addEventListener('click', (e) => {
      if (e.target.tagName.toLowerCase() === 'a') return;
      e.preventDefault();
    });

    // Open on hover summary
    this.summary.addEventListener('mouseenter', this.onOpen.bind(this));
    // Keep open when hovering submenu
    this.content.addEventListener('mouseenter', this.onOpen.bind(this));

    // Close only when leaving both
    this.summary.addEventListener('mouseleave', this.onMaybeClose.bind(this));
    this.content.addEventListener('mouseleave', this.onMaybeClose.bind(this));
  }

  onOpen() {
    if (!this.header) return;
    this.mainDetailsToggle.open = true;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMaybeClose() {
    // Delay a bit and check if neither summary nor content are hovered
    setTimeout(() => {
      if (!this.summary.matches(':hover') && !this.content.matches(':hover')) {
        this.mainDetailsToggle.open = false;
      }
    }, 50);
  }

  onToggle() {
    return;
  }
}

customElements.define('header-menu', HeaderMenu);
